module.exports = __webpack_public_path__ + "static/img/home_func4.e6510cdc.png";